import { FC } from 'react';
import { Box, Button, Typography } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
// @ts-ignore TS2307: Cannot find module 'assets/pdfs/esg-imp-demo.pdf' or its corresponding type declarations
import EsgImpDemo from 'assets/pdfs/esg-imp-demo.pdf';
import esg from 'assets/images/esg-baner.jpg';
import { ESGLearnMoreModalProps } from './ESGLearnMoreModal.d';
import { DialogStyled, ModalHeader, ImageWrapper } from './ESGLearnMoreModal.styled';

export const ESGLearnMoreModal: FC<ESGLearnMoreModalProps> = ({
  open,
  onClose,
  onContactSales,
}) => {
  return (
    <DialogStyled open={open} onClose={onClose} maxWidth="md">
      <Box p={3}>
        <ModalHeader>
          <Typography variant="h5">ESG Impact assessment</Typography>
          <CloseIcon onClick={onClose} />
        </ModalHeader>
        <Box my={4}>
          <Typography variant="subtitle1">
            Zoom into the company’s sustainability profile with ESG impact assessment!
          </Typography>
        </Box>
        <ImageWrapper>
          <img src={esg} alt="" />
        </ImageWrapper>
        <Box my={4}>
          <Typography variant="subtitle1">
            Learn about the relative ESG industry position of a company and how Scope ESG scores its
            ambition to reach relevant sustainability targets.
          </Typography>
        </Box>
        <Box display="flex" justifyContent="flex-end" mt={4}>
          <Box mr={2}>
            <Button
              startIcon={<CloudDownloadIcon />}
              variant="contained"
              href={EsgImpDemo}
              download="esg-imp-demo.pdf"
            >
              Download sample report
            </Button>
          </Box>
          <Button variant="contained" onClick={onContactSales}>
            Contact Sales
          </Button>
        </Box>
      </Box>
    </DialogStyled>
  );
};
